import React from "react";
import {
  Form,
  Input,
  Select,
  Checkbox,
  DatePicker,
  Button,
  Radio,
  Typography,
  Flex,
} from "antd";
const { Text, Paragraph, Title } = Typography;

const { Option } = Select;

const BookingForm = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    
  };

  return (
    <div className="container">
      <Title className="!font-medium !text-danger !text-3xl !mb-1" level={2}>
        <span className="text-primary">Kyrgyzstan Tour Package </span> – Fill
        the form and Book Now
      </Title>

      <Paragraph className="font-medium">
        Please select flight and hotel category
      </Paragraph>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className="bookingForm mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6"
      >
        <Flex gap={15}>
          {/* Title */}
          <Form.Item name="title" label="Title" className="col-span-1 w-40">
            <Select placeholder="Mr.">
              <Option value="Mr.">Mr.</Option>
              <Option value="Ms.">Ms.</Option>
              <Option value="Mrs.">Mrs.</Option>
            </Select>
          </Form.Item>

          {/* First Name */}
          <Form.Item
            name="firstName"
            label="First Name"
            className="col-span-1 w-full"
            rules={[
              { required: true, message: "Please enter your first name" },
            ]}
          >
            <Input />
          </Form.Item>
        </Flex>
        {/* Last Name */}
        <Form.Item
          name="lastName"
          label="Last Name"
          className="col-span-1"
          rules={[{ required: true, message: "Please enter your last name" }]}
        >
          <Input />
        </Form.Item>

        {/* Email */}
        <Form.Item
          name="email"
          label="E-mail"
          className="col-span-1"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input />
        </Form.Item>

        {/* Country of Residence */}
        <Form.Item
          name="residence1"
          label="Country of Residence"
          className="col-span-1"
        >
          <Select placeholder="Select country">
            <Option value="UAE">UAE</Option>
            <Option value="India">India</Option>
            <Option value="Other">Other</Option>
          </Select>
        </Form.Item>

        {/* Country of Residence 2 */}
        <Form.Item
          name="residence2"
          label="Country of Residence"
          className="col-span-1"
        >
          <Input />
        </Form.Item>

        {/* Phone Number */}
        <Form.Item
          name="phone"
          label="Phone number"
          className="col-span-1"
          rules={[{ required: true, message: "Please enter phone number" }]}
        >
          <Input />
        </Form.Item>

        {/* Nationality */}
        <Form.Item
          name="nationality"
          label="Choose your Nationality"
          className="col-span-1"
        >
          <Select placeholder="Select nationality">
            <Option value="Indian">Indian</Option>
            <Option value="UAE">UAE</Option>
            <Option value="Other">Other</Option>
          </Select>
        </Form.Item>

        {/* DOB */}
        <Form.Item
          name="dob"
          label="Date of Birth"
          className="col-span-1"
          rules={[{ required: true, message: "Please select your DOB" }]}
        >
          <DatePicker className="w-full" />
        </Form.Item>

        {/* Number of Travellers */}
        <Form.Item
          name="travellers"
          label="Number of Travellers"
          className="col-span-1"
        >
          <Input type="number" min={1} />
        </Form.Item>

        {/* T&C */}
        <Form.Item name="terms" valuePropName="checked" className="col-span-3">
          <Checkbox className="font-normal text-base">
            I have read and agree to Terms and Conditions
          </Checkbox>
        </Form.Item>

        {/* Payment & Submit */}
        <div className="col-span-3 flex flex-wrap items-center justify-between gap-4 border-y py-4">
          <div className="flex items-center gap-2">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
              alt="Visa"
              className="h-6"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Mastercard_2019_logo.svg"
              alt="MasterCard"
              className="h-6"
            />
            <Radio defaultChecked>Pay by Credit - Debit Card</Radio>
          </div>

          <Button
            type="danger"
            size="middle"
            className="font-medium px-12 py-6 text-sm rounded-tl-[12px] 
            rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md text-white"
          >
            Book Now
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default BookingForm;
